// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@mixin transition() {
    transition: all .4s cubic-bezier(.215,.61,.355,1);
}

.deletebutton {
	position: relative;
	width: 30px;
	height: 30px;
}

.deletebutton a {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ffffff;
    border-radius: 50px;
    opacity: 1;
    transition: all .4s cubic-bezier(.215,.61,.355,1);
}  

.deletebutton .left, .deletebutton .right {
      background-color: #ffe8de;
      display: block;
      height: 4px;
      border-radius: 5px;
      position: relative;
      transition: all .4s cubic-bezier(.215,.61,.355,1);
      position: absolute;
      top: 50%;
      margin-top: 4px;
      left: 2px;
      width: 22px;
      display: flex;
      justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
}

.deletebutton span {
	display: block;
	background-color: #fdd1be;
	width: 2px;
	height: 2px;
	border-radius: 6px;
	transition: all .4s cubic-bezier(.215,.61,.355,1);
	position: absolute;
	left: 0;
	top: 0;
}

.deletebutton .left {
        transform: rotate(45deg);
        transform-origin: center;
}

.deletebutton .left .circle-left {
          transition: all .4s cubic-bezier(.215,.61,.355,1);
          margin-left: 0;
}

.deletebutton .left .circle-right {
	transition: all .4s cubic-bezier(.215,.61,.355,1);
	margin-left: 20px;
}

.deletebutton .right {
        transform: rotate(-45deg);
        transform-origin: center; 
}

.deletebutton .right .circle-left {
          transition: all .4s cubic-bezier(.215,.61,.355,1);
          margin-left: 0;
}

.deletebutton .right .circle-right {
          transition: all .4s cubic-bezier(.215,.61,.355,1);
          margin-left: 20px;
        }

.deletebutton:hover .left ,.deletebutton:hover .right {
        background-color: #ff8855;
        transition: all .4s cubic-bezier(.215,.61,.355,1);
}

.deletebutton:hover span {
          transition: all .4s cubic-bezier(.215,.61,.355,1);
          background-color: #ff6827;
}

.deletebutton:hover .left .circle-left {
            transition: all .4s cubic-bezier(.215,.61,.355,1);
            margin-left: 20px;
          }

.deletebutton:hover .left .circle-right {
            transition: all .4s cubic-bezier(.215,.61,.355,1);
            margin-left: 0;
          }

.deletebutton:hover .right .circle-left {
            transition: all .4s cubic-bezier(.215,.61,.355,1);
            margin-left: 20px;
}

.deletebutton:hover .right .circle-right {
            transition: all .4s cubic-bezier(.215,.61,.355,1);
            margin-left: 0;
          }`, "",{"version":3,"sources":["webpack://./src/assets/css/closeDeleteButton.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;AACrD;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,iDAAiD;AACrD;;AAEA;MACM,yBAAyB;MACzB,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,kBAAkB;MAClB,iDAAiD;MACjD,kBAAkB;MAClB,QAAQ;MACR,eAAe;MACf,SAAS;MACT,WAAW;MAKX,aAAa;MAEb,8BAA8B;MAC9B,mCAAmC;MACnC,kCAAkC;AACxC;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,iDAAiD;CACjD,kBAAkB;CAClB,OAAO;CACP,MAAM;AACP;;AAEA;QACQ,wBAAwB;QACxB,wBAAwB;AAChC;;AAEA;UACU,iDAAiD;UACjD,cAAc;AACxB;;AAEA;CACC,iDAAiD;CACjD,iBAAiB;AAClB;;AAEA;QACQ,yBAAyB;QACzB,wBAAwB;AAChC;;AAEA;UACU,iDAAiD;UACjD,cAAc;AACxB;;AAEA;UACU,iDAAiD;UACjD,iBAAiB;QACnB;;AAER;QACQ,yBAAyB;QACzB,iDAAiD;AACzD;;AAEA;UACU,iDAAiD;UACjD,yBAAyB;AACnC;;AAEA;YACY,iDAAiD;YACjD,iBAAiB;UACnB;;AAEV;YACY,iDAAiD;YACjD,cAAc;UAChB;;AAEV;YACY,iDAAiD;YACjD,iBAAiB;AAC7B;;AAEA;YACY,iDAAiD;YACjD,cAAc;UAChB","sourcesContent":["@mixin transition() {\n    transition: all .4s cubic-bezier(.215,.61,.355,1);\n}\n\n.deletebutton {\n\tposition: relative;\n\twidth: 30px;\n\theight: 30px;\n}\n\n.deletebutton a {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    background-color: #ffffff;\n    border-radius: 50px;\n    opacity: 1;\n    transition: all .4s cubic-bezier(.215,.61,.355,1);\n}  \n\n.deletebutton .left, .deletebutton .right {\n      background-color: #ffe8de;\n      display: block;\n      height: 4px;\n      border-radius: 5px;\n      position: relative;\n      transition: all .4s cubic-bezier(.215,.61,.355,1);\n      position: absolute;\n      top: 50%;\n      margin-top: 4px;\n      left: 2px;\n      width: 22px;\n      display: -webkit-box;\n      display: -moz-box;\n      display: -ms-flexbox;\n      display: -webkit-flex;\n      display: flex;\n      -webkit-justify-content: space-between;\n      justify-content: space-between;\n      -moz-justify-content: space-between;\n      -ms-justify-content: space-between;\n}\n\n.deletebutton span {\n\tdisplay: block;\n\tbackground-color: #fdd1be;\n\twidth: 2px;\n\theight: 2px;\n\tborder-radius: 6px;\n\ttransition: all .4s cubic-bezier(.215,.61,.355,1);\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n}\n\n.deletebutton .left {\n        transform: rotate(45deg);\n        transform-origin: center;\n}\n\n.deletebutton .left .circle-left {\n          transition: all .4s cubic-bezier(.215,.61,.355,1);\n          margin-left: 0;\n}\n\n.deletebutton .left .circle-right {\n\ttransition: all .4s cubic-bezier(.215,.61,.355,1);\n\tmargin-left: 20px;\n}\n\n.deletebutton .right {\n        transform: rotate(-45deg);\n        transform-origin: center; \n}\n\n.deletebutton .right .circle-left {\n          transition: all .4s cubic-bezier(.215,.61,.355,1);\n          margin-left: 0;\n}\n\n.deletebutton .right .circle-right {\n          transition: all .4s cubic-bezier(.215,.61,.355,1);\n          margin-left: 20px;\n        }\n\n.deletebutton:hover .left ,.deletebutton:hover .right {\n        background-color: #ff8855;\n        transition: all .4s cubic-bezier(.215,.61,.355,1);\n}\n\n.deletebutton:hover span {\n          transition: all .4s cubic-bezier(.215,.61,.355,1);\n          background-color: #ff6827;\n}\n\n.deletebutton:hover .left .circle-left {\n            transition: all .4s cubic-bezier(.215,.61,.355,1);\n            margin-left: 20px;\n          }\n\n.deletebutton:hover .left .circle-right {\n            transition: all .4s cubic-bezier(.215,.61,.355,1);\n            margin-left: 0;\n          }\n\n.deletebutton:hover .right .circle-left {\n            transition: all .4s cubic-bezier(.215,.61,.355,1);\n            margin-left: 20px;\n}\n\n.deletebutton:hover .right .circle-right {\n            transition: all .4s cubic-bezier(.215,.61,.355,1);\n            margin-left: 0;\n          }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
